import { Navigate, Outlet, useLocation } from 'react-router';

import { AuthLoadingScreen } from '@/components/layout/auth-loading';
import { useAuth } from '@/hooks/use-auth';
import { buildRedirectState } from '@/lib/redirect-path';

export function TermsGuard() {
  const { isLoading, termsAccepted } = useAuth();
  const location = useLocation();
  const redirectState = buildRedirectState(location);

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!termsAccepted) {
    return <Navigate to="/terms" replace state={redirectState} />;
  }

  return <Outlet />;
}
